import React from "react";
import LandingHeader from "./LandingHeader.tsx";
import SectionFooter from "./SectionFooter.tsx";

export default function Public404Page() {
    return (
        <div className={'LandingPage text-[#e6e1e6]'}>
            <section className="Section pb-12">

                <LandingHeader />

                <div className="SectionHeading">
                    <h1>
                        Error 404
                    </h1>

                    <div>
                        This page does not exist.
                    </div>
                </div>

            </section>

            <SectionFooter className="rounded-none" />

        </div>
    );
};
